module.exports = __webpack_public_path__ + "static/media/24UHCHR11.64790313.jpg";